import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Wirkprinzipprocess() {
  const benefits = ["Sanfte Vodder-Lymphdrainage Methode", "Moderne 12-Kammer-Drucktherapie", "Ganzheitliche Entschlackung & Regeneration", "Sichtbare Ergebnisse für Körper & Wohlbefinden"];
  return <section data-section-id="221965" id="wirkprinzipprocess" className="bg-background text-foreground">
      <div className="w-full bg-accent">
        
      </div>
    </section>;
}